module.exports = __webpack_public_path__ + "assets/media/rocket.bb41c117.svg";